<template>
  <b-card title="Extrato X Transações">
    <b-col md="12">
      <b-form-select
        v-model="selectedEC"
        :options="dropdownOptions"
        class="mb-2"
      />
    </b-col>
    <div v-if="loading" class="text-center my-4">
      <b-spinner label="Carregando..." variant="primary" />
    </div>
    <b-table
      v-else
      :items="filteredItems"
      :fields="formattedFields"
      small
      bordered
      responsive
      :per-page="15"
      :current-page="currentPage"
      @row-clicked="openModal"
    ></b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="items.length"
      :per-page="15"
      align="center"
      size="sm"
      class="my-0"
    />
    <b-modal
      id="details-modal"
      ref="detailsModal"
      title="Detalhes do EC"
      hide-footer
    >
      <div v-if="selectedRow">
        <p><strong>EC: </strong> {{ selectedRow.ec }}</p>
        <p><strong>Nome: </strong> {{ selectedRow.name }}</p>
        <p><strong>Valor do Extrato: </strong>{{ formatCurrency(selectedRow.extractPaymentDif.extractValue) }} </p>
        <p><strong>Valor da liquidação: </strong>{{ formatCurrency(selectedRow.extractPaymentDif.paymentValue) }} </p>
        <p><strong>Diferença: </strong>{{ formatCurrency(selectedRow.extractPaymentDif.dif) }} </p>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BCard,
  BCol,
  BFormGroup,
  BTable,
  BPagination,
  BFormSelect,
  BModal,
  BSpinner,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCol,
    BFormGroup,
    BTable,
    BPagination,
    BFormSelect,
    BModal,
    BSpinner,
  },
  props: {
    items: Array,
    dropdownOptions: Array,
    selectedEC: String,
    formattedFields: Array,
    loading: Boolean,
    rawTableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentPage: 1,
      selectedRow: null,
    };
  },
  computed: {
    filteredItems() {
      if (this.selectedEC) {
        return this.items.filter((item) => item.ec === this.selectedEC);
      }
      return this.items;
    },
  },
  methods: {
    openModal(row) {
      const fullData = this.rawTableData.find((item) => item.ec === row.ec);
      if (fullData) {
        this.selectedRow = fullData;
        this.$refs.detailsModal.show();
      }
    },
       formatCurrency(value) {
      return Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
    },
  },
};
</script>
